module.exports = __webpack_public_path__ + "static/img/jx-jxjl.113c2ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/jx-jxjl.png
// module id = 9e84
// module chunks = 0